/*
 * @Description:
 * @usage:
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-get-tab-experiment/index.ts
 */
import { useStore, MutationTypes } from '@/store';
import { getTABSdk } from '@/utils/script';

export default function useGetTabExperiment() {
  const store = useStore();
  async function getTabExp(id: string) {
    const wabt = await getTABSdk();
    if (!wabt) return null;

    // @ts-ignore
    wabt?.init({
      appid: '8801', // TAB平台的业务id
      appkey: '97ea3cfb64eeaa1edba65501d0bb3c86', // 微视Web业务的appKey
      guid: id, // 可选，传人一个用户身份，用来做分流标识。这里用的uid
      timeout: 500, // 可选，配合onNetData使用
    });
    // 强制刷新,不走tab缓存
    // @ts-ignore
    await wabt?.forceReload();
    // 根据实验 ID 名称获取实验
    try {
      // @ts-ignore
      const expRes = await wabt?.getExpByNameAndReport('exp_sharing_page_transformation_experiment');

      if (expRes.params.isNew) {
        store.commit(MutationTypes.SET_IS_NEW_PAGE, {
          value: true,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  return {
    getTabExp,
  };
}
